import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const showLiquidationNotificationsAtom = atomWithStorage<boolean>(
  "showLiquidationNotifications",
  true,
  undefined,
  { getOnInit: true },
);

export const useShowLiquidationNotifications = () => {
  const [showLiquidationNotifications, setShowLiquidationNotifications] =
    useAtom(showLiquidationNotificationsAtom);

  return {
    showLiquidationNotifications,
    setShowLiquidationNotifications,
  };
};
